<ng-container *ngIf="passwordExpiry == false">
    <ng-container *ngIf="twoFAMethod == 'APP'">
        <p *ngIf="setup">
            Please fill in the 6 digit code that has been generated
            in the authentication app to finish the setup.
        </p>
        <p *ngIf="!setup && !pendingAppState">
            Enter the verification code sent to your authentication app.
        </p>
        <p *ngIf="!setup && pendingAppState">
            The setup of your device did not complete.<br> Please enter the last verification code you received on able
            + authentication app, or enter setup by clicking the link below.
        </p>
    </ng-container>
    <ng-container *ngIf="twoFAMethod == 'SMS'">
        <p *ngIf="setup">
            Please fill in the 6 digit code sent via SMS to *******{{numberLastDigits}} to finish the setup.
        </p>
        <p *ngIf="!setup">
            Enter the verification code sent via SMS to *******{{numberLastDigits}}
        </p>
    </ng-container>
    <form #f="ngForm" class="no-right-padding" novalidate>
        <div class="row no-right-padding">
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit1" name="digit1" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit2" name="digit2" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit3" name="digit3" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit4" name="digit4" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit5" name="digit5" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding form-group">
                <input [(ngModel)]="model.digit6" name="digit6" required type="text" (click)="putCursorAtEnd($event)"
                    (keyup)="onKeyUp($event)" maxlength="1" value="" class="form-control text-center">
            </div>
        </div>
        <div class="text-center margin-top-base padding-top-base">
            <input type="submit" class="btn btn-primary btn-block" value="VERIFY" [disabled]="!f.form.valid"
                [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
                (click)="verifyCode()" />
        </div>
    </form>
    <ng-container *ngIf="!setup">
        <div *ngIf="!pendingAppState && twoFAMethod != 'APP' && isChangingDevice == false" class="footer text-center">
            <p class="small">
                <a style="cursor: pointer" (click)="resendCode(twoFAMethod)">
                    Send new code</a>
            </p>
        </div>
        <div *ngIf="methodsSetup =='BOTH'" class="footer text-center">
            <p class="small">
                <a *ngIf="twoFAMethod=='SMS'" style="cursor: pointer" (click)="switch2FAMethod()">
                    Generate verification code using app</a>
                <a *ngIf="twoFAMethod=='APP' && smsEnabled" style="cursor: pointer" (click)="switch2FAMethod()">
                    Generate verification code using SMS</a>
            </p>
        </div>
        <div *ngIf="twoFAMethod=='SMS' && methodsSetup =='SMS'" class="footer text-center">
            <p class="small">
                <a routerLink='/2FA-setup' routerLinkActive="active">
                    Set up mobile to receive codes via able+ app</a>
                <br>
                <a *ngIf="pendingAppState==true" style="cursor: pointer" (click)="changeTwoFaMethod('APP')">
                    Enter the last confirmation number from able+ app</a>

            </p>
        </div>
        <div *ngIf="twoFAMethod=='APP' && methodsSetup =='APP' && smsEnabled" class="footer text-center">
            <p class="small">
                <a routerLink='/2FA-setup' routerLinkActive="active">
                    Set up mobile to receive codes via SMS</a>
            </p>
        </div>
        <div *ngIf="twoFAMethod=='APP' && methodsSetup ==''" class="footer text-center">
            <p class="small">
                <a routerLink='/2FA-setup' routerLinkActive="active">
                    Enter the set up again to configure 2 FA</a>
            </p>
        </div>
        <div *ngIf="twoFAMethod=='APP' && methodsSetup =='SMS' " class="footer text-center">
            <p class="small">
                <a routerLink='/2FA-setup' routerLinkActive="active">
                    Setup able+ app</a>
            </p>

        </div>
        <div *ngIf="twoFAMethod=='APP' && methodsSetup =='SMS' && smsEnabled && userConfig?.smsAuthenticator?.phoneNumber"
            class="footer text-center">
            <p class="small">
                <a style="cursor: pointer" (click)="switch2FAMethod()">
                    Generate code via SMS</a>
            </p>
        </div>
        <div *ngIf="twoFAMethod=='SMS'" class="footer text-center">
            <p class="small">
                <a style="cursor: pointer" (click)="changeMobileNo()">
                    Change mobile number</a>
            </p>
        </div>
        <div *ngIf="twoFAMethod=='APP' && !pendingAppState" class="footer text-center">
            <p class="small">
                <a style="cursor: pointer" (click)="changeDeviceBinding()">
                    Change device</a>
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="setup && methodsSetup==''">
        <div class="footer text-center">
            <p class="small">
                <a style="cursor: pointer" (click)="onGoToSetup()">
                    Go back to 2 factor authentication setup</a>
            </p>
        </div>
    </ng-container>
    <ng-container
        *ngIf="setup && ((methodsSetup=='APP' || this.userConfig?.appAuthenticator?.authorisationStatus == 'PENDING') || methodsSetup=='BOTH' || (methodsSetup=='SMS' && smsEnabled))">
        <div class="footer text-center">
            <p class="small">
                <a routerLink='/2FA-authentication' routerLinkActive="active">
                    Go back to 2 factor authentication</a>
            </p>
        </div>
    </ng-container>
</ng-container>

<div *ngIf="passwordExpiry">
  <div>
    <password-expiry
      *ngIf="peopleData!=undefined"
      [userLogged]="peopleData"
      [passwordExpirySettings]="{
        hasExpired,
        checkFirstLogin,
        passwordExpiry,
        passwordDaysExpire
      }"
      (skip)="onSkip()"
      (reset)="onReset()"
    >
    </password-expiry>
  </div>
</div>
